/**
 * Personal 1:1 dialog with a human user.
 * Bots and any chats (channels/groups/publics) are out of scope for
 * Messario templates / offers / AI composer tools.
 */
export function isMessarioUserDialogPeer(
  peerId: PeerId | undefined,
  isBot = false
): boolean {
  return !!peerId && peerId.isUser() && !isBot;
}
